<!-- 견적서 작성 -->
<template>
  <div>
    <admin-box-item title="카테고리 수정" :useTab="false" v-if="value!==undefined">
      <div class="columns is-multiline">
        <div class="column is-7">
          <admin-form-item label="카테고리 명">
            <input class="input"
                   :value="value.name"
                   @input="e => value.name = e.target.value"
                   type="text">
          </admin-form-item>
        </div>

      </div>
      <div class="btn-group-justify-end">
        <button class="button is-light" @click="deleteCat">삭제</button>
        <div class="button is-primary" @click="saveCat">저장하기</div>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";

  export default {
    props: {
      data: {
        type: Object
      }
    },
    components: {
      AdminFormItem
    },
    data() {
      return {
        value: {}
      }
    },
    created() {
      this.getCatDetail();
    },
    watch: {
      data(n) {
        if (n) {
          this.getCatDetail();
        }
      }
    },
    methods: {
      getCatDetail(){
        this.value = this.cloneItem(this.data);
      },
      deleteCat() {
        if(confirm(`${this.data.name} 카테고리를 삭제하시겠습니까?`)) {
          this.$axios.delete(this.getUrl(`memo_category/${this.data.id}`))
            .then(res => {
              if(res.status===200) {
                this.toast('카테고리가 삭제되었습니다.');
                this.$emit('delete');
              }
            });
        }
      },
      saveCat() {
        this.$axios.patch(this.getUrl('memo_category/'+this.value.id), this.value)
          .then(res => {
            this.toast('저장되었습니다.');
            this.value.label = this.value.name;
            this.$emit('update:data', this.value);
            this.$emit('saved');
          });
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

</style>
